import jwtAuthAxios from "../auth/jwtAuth";

// Controles «Mantener en rango» (lazos de control). Hablan en minutos, horas y un tope de seguridad.
const controlLoopServices = {};

controlLoopServices.getControlLoop = async (id) => {
    const { data } = await jwtAuthAxios.get(`/automations/control_loops/${id}`);
    return data;
};

controlLoopServices.getEditOptions = async ({ controlLoopId } = {}) => {
    const { data } = await jwtAuthAxios.get("/automations/control_loops/edit_options", {
        params: controlLoopId ? { control_loop_id: controlLoopId } : {},
    });
    return data;
};

controlLoopServices.createControlLoop = async (controlLoop) => {
    const { data } = await jwtAuthAxios.post("/automations/control_loops", { control_loop: controlLoop });
    return data;
};

controlLoopServices.updateControlLoop = async (id, controlLoop) => {
    const { data } = await jwtAuthAxios.put(`/automations/control_loops/${id}`, { control_loop: controlLoop });
    return data;
};

controlLoopServices.deleteControlLoop = async (id) => {
    const { data } = await jwtAuthAxios.delete(`/automations/control_loops/${id}`);
    return data;
};

export default controlLoopServices;
